import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import PointManagementList from './components/PointManagementList';

const { Cell } = ResponsiveGrid;

const HouseholdPoints = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="點數記錄列表"
        // description="公告事項"
        breadcrumbs={[
          {
            name: '點數管理',
          },
          {
            name: '點數記錄列表',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <PointManagementList />
    </Cell>
  </ResponsiveGrid>
);

export default HouseholdPoints;
